import React from 'react';
import PreLoginPage from '../../../views/core/PreLoginPage';
import Feature1 from '../../../images/icons/Feature1.png';
import Feature2 from '../../../images/icons/program_highlights/ph2.png';
import Feature3 from '../../../images/icons/program_highlights/ph3.png';
import Feature4 from '../../../images/icons/program_highlights/ph4.png';

// ES6 class-style
class LessonFeatures extends PreLoginPage {
  render() {
  	return(
	<div data-p-ga="" id="LessonFeatures">
		<div className="container">			
			<div className="row">
            <span>{this.rb("custom.label.txt.2")}</span>
			    <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                    <img src={Feature1} alt="student listening to video lecture" />
                    <h3>{this.rb("lessonfeatures2.label.1")}</h3>
                    <p>{this.rb("lessonfeatures2.txt.1")}</p>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                    <img src={Feature2} alt="Bite-sized quizzes" />
                    <h3>{this.rb("lessonfeatures2.label.2")}</h3>
                    <p>{this.rb("lessonfeatures2.txt.2")}</p>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                    <img src={Feature3} alt=" Diagnostic test report" />
                    <h3>{this.rb("lessonfeatures2.label.3")}</h3>
                    <p>{this.rb("lessonfeatures2.txt.3")}</p>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                    <img src={Feature4} alt="Granular report card" />
                    <h3>{this.rb("lessonfeatures2.label.4")}</h3>
                    <p>{this.rb("lessonfeatures2.txt.4")}</p>
                </div>
            </div>
		</div>
	</div>
  	);
  }
}

export default LessonFeatures;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/LessonFeatures2.js